import { isNumber } from 'lodash';
import React from 'react';
import { NumberInput } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { imageWidth } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const ImageWidth = (props) => {
  const { disabled } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Section {...sectionProps}>
      <ItemWrapper
        title={getI18n('salesChannelContent.index.imageWidth')}
        size='small'>
        <Field name={imageWidth}>
          {(props, meta) => {
            return (
              <NumberInput
                suffix={'px'}
                value={props.value}
                min={0}
                size={'large'}
                disabled={disabled}
                onChange={(imageWidth) => {
                  if (isNumber(imageWidth)) {
                    props.onChange(imageWidth);
                    return;
                  }
                  props.onChange(0);
                }}
              />
            );
          }}
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default ImageWidth;
